export class VideoCursor {
	private $container: HTMLElement;
	private $caption: HTMLElement;
	private offsetX: number;
	private offsetY: number;

	private readonly classVisible: string = 'video-cursor--visible';

	constructor(container: HTMLElement, offsetX = 0, offsetY = 0) {
		this.$container = container;
		this.offsetX = offsetX;
		this.offsetY = offsetY;

		this.createCaption();
		this.initEvents();
	}

	private createCaption = (): void => {
		this.$caption = document.createElement('div');
		this.$caption.className = 'video-cursor';
		this.$container.appendChild(this.$caption);
	};

	private initEvents = (): void => {
		this.$container.addEventListener('mousemove', this.onMouseMove);
		this.$container.addEventListener('mouseleave', this.onMouseLeave);
		this.$container.addEventListener('click', this.onClick);
	};

	private onMouseMove = (e: MouseEvent): void => {
		this.$caption.textContent = this.$container.dataset.cursorCaption || '';
		this.$caption.classList.add(this.classVisible);

		const rect = this.$container.getBoundingClientRect();
		const x = e.clientX - rect.left + this.offsetX;
		const y = e.clientY - rect.top + this.offsetY;

		this.$caption.style.left = `${x}px`;
		this.$caption.style.top = `${y}px`;
	};

	private onMouseLeave = (): void => {
		this.$caption.classList.remove(this.classVisible);
	};

	private onClick = (): void => {
		const action = this.$container.dataset.cursorAction;
		if (!action) return;

		const event = new CustomEvent('video-cursor-action', { detail: action });
		this.$container.dispatchEvent(event);
	};

	public destroy = (): void => {
		this.$container.removeEventListener('mousemove', this.onMouseMove);
		this.$container.removeEventListener('mouseleave', this.onMouseLeave);
		this.$container.removeEventListener('click', this.onClick);
		this.$caption.remove();
	};
}
